import React, {useEffect} from 'react';
import './StripeThreeDs.less';
import { PseudoPagePopup } from '../../dialog-layout/pseudo-page-popup/PseudoPagePopup';

export const StripeThreeDs = (
	{
        redirectUrl,
        on3DSSuccessful,
        onOverlayClick
	}
) => {
	
	function onMessagePosted(e) {
		if (!e) return;
		if (typeof e.data !== 'string') return;
		if (!e.origin.includes('snappo.com') && !e.origin.includes('weorder.com') && !e.origin.includes('localhost')) return;
		
		if (e.data === '3DS-authentication-complete') {
			on3DSSuccessful();
		}
	}
	
	useEffect(() => {
		window.addEventListener('message', onMessagePosted, false);
		
		return () => {
			window.removeEventListener('message', onMessagePosted, false);
		}
	}, []);
	

    return (<PseudoPagePopup onBackClick={onOverlayClick}>
        <iframe
            className="stripe-threeds-frame"
			src={redirectUrl}
            height="100%"
            width="100%"
            frameBorder="0"
        />
    </PseudoPagePopup>)
}

